const state = {
  sidebarHide: false, // 侧边栏是否隐藏
}

const mutations = {
  TOGGLE_SIDEBAR_HIDE: (state, hide) => {
    state.sidebarHide = hide
  }
}

const actions = {
  toggleSideBarHide({ commit }, hide) {
    commit('TOGGLE_SIDEBAR_HIDE', hide)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
